module.exports = __webpack_public_path__ + "img/arm-dual-claw.2f871e53.png";